import { BasicComponentProps } from '@whoop/web-components/dist/types';
import React from 'react';
import Description from '../Description';

function Error({ children, ...props }: BasicComponentProps) {
  return (
    <Description type="error" {...props}>
      {children}
    </Description>
  );
}

export default Error;
